<template>
  <div class="mobile-wrap" ref="homePage">
    <!-- <div id="app"> -->
    <div v-if="platform === 'mobile'">
      <div class="pic">
        <!-- <h1 class="title">新冠肺炎實聯系統</h1>
        <h5>COVID-19 real-name contact system</h5> -->
        <img src="../img/Logo.png" alt="" >
      </div>
       <!-- AuthToken -->
      <!-- <cube-textarea class="item" :placeholder="transform" disabled >
      </cube-textarea> -->
        <!-- 選擇國碼 -->
        <cube-select class="item" icon="perm_identity" @change="change" v-model="countryCode" confirmTxt="確認" title="請選擇" placeholder="選擇國碼" :options="countries" :disabled="phoneVerify">
          <!-- <mu-option v-for="(code, index) in countries" :key="index" :label="$t(code.text)" :value="code.value"></mu-option> -->
        </cube-select>
        <!-- 輸入電話 -->
        <!-- <cube-input   class="item"  v-model="phoneNumber"  :placeholder="$t('Login.authHint') + countries.filter(el => el.value === countryCode).map(el => el.example)[0]" :disabled="phoneVerify">
        </cube-input> -->
        <cube-input  class="item" :maxlength="10" v-model="phoneNumber"  :placeholder="place(countryCode)" :disabled="phoneVerify">
        </cube-input>
        <!-- <div class="recaptcha-container" id="recaptcha-container"></div> -->
        <!-- 認證按鈕 -->
        <cube-button id="sign-in-button" class="item"  style="transform: translateY(0px);" @click="checkingPhone"  :disabled="phoneNumber === '' || number !== ''">{{ $t('Login.verify') }} {{number}}</cube-button>
        <!-- 輸入驗證碼 -->
        <cube-input   class="item" placeholder="請輸入驗證碼" v-model="verCode" v-if="phoneVerify" ></cube-input>
        <cube-button id="sign-in-button" class="item" v-if="phoneVerify" size="medium" style="transform: translateY(0px);" @click="codeVer" >{{ $t('Login.verify') }}</cube-button>

        <cube-button v-if="brandData && brandData.shopNo.length === 15" id="sign-in-button" class="item"  style="transform: translateY(0px);" @click="goUrl">唐鳳版簡訊實聯制</cube-button>

        <!-- <a href="sms:1922?body=場所代碼:A000本簡訊是簡訊實聯制發送，限防疫目的使用">唐鳳版簡訊實聯制</a> -->
      <div class="bottom">
        <img src="../img/eilis.png" alt="Smiley face" height="14" width="">
        <div style="transform: scale(0.7)"> 智慧互動助理提供</div>
      </div>
    </div>
    <!-- QR Code -->
    <div v-if="platform === 'desktop'">
      <div style="border: 1px solid #cbced3; display: inline-block; padding: 20px; padding-bottom: 12px; margin-top: 40px; width: 200px;">
        <qrcode-vue :value="qrcode" size="150" level="H"></qrcode-vue>
      </div>
      <div style="margin-top: 15px;">
        {{ $t('Login.no_service') }}<br>{{ $t('Login.scan_code') }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from 'vuex'
import axios from 'axios';

const CryptoJS = require('crypto-js');

export default {
  data () {
    return {
      // EMC LITE
      logo: '',
      //
      availHeight: '',
      crossPlatform: false,
      phone: '',
      //
      userId: '',
      number: '',
      tempCode: '198911',
      phoneVerify: false,
      loading: false,
      value: '',
      platform: '',
      verCode: '',
      AuthToken: this.$route.params.Auth_u,
      Service: this.$route.params.service,
      alert: false,
      alertmessage: '電話號碼還未輸入喔！',
      countryCode: '886',
      channelData: {
        AuthToken: this.$route.query.Auth,
        Service: this.$route.params.service,
        // PhoneNumber: '',
        Name: this.$route.query.Name ? this.$route.query.Name : '',
        PageID: this.$route.query.Page,
        trigger: this.$route.query.trigger,
        Img: this.$route.query.Img,
        transactionId: this.$route.query.transactionId,
        Point: this.$route.query.Point
      },
      countries:[
        {
          text: '台灣(+886)',
          value: '886',
          example: '0912345678'
        },
        {
          text: '柬埔寨(+855)' ,
          value: '855',
          example: '091234567'
        },
        // {
        //   text: '馬來西亞(+60)',
        //   value: '60',
        //   example: '0123456789'
        // }
      ],
    }
  },
  mounted() {
    // console.log(this.brandData);
    // this.logo = this.eilisProfile.logo
    this.platform = 'mobile';
    // console.log(localStorage.getItem('brand'));
    this.availHeight = `${window.screen.availHeight}`;
    this.$refs.homePage.style.height = this.availHeight+ 'px';
    // console.log(this.availHeight+ 'px');
  },
  watch: {
    countryCode: {
      handler: function(countryCode) {
        // console.log(countryCode);
        if (countryCode === '886') {
          this.storeCountryCode = this.countryCode;
        }
      },
      deep: true,
      immediate: true
    },
    // 監聽驗證碼輸入為6碼
    verCode(newV) {
      if (newV.length > 6) {
        newV = newV.slice(0, 6)
        this.$nextTick(() => {
          this.verCode = newV
        })
      }
    },
    phoneNumber(val) {
      const re = /^[0-9]+$/;
      if (!re.test(val)) {
        this.Alert();
        this.$nextTick(() => {
          this.phoneNumber = '';
        })
      }
    },
  },
  computed: {
    ...mapGetters({
      eilisProfile: 'eilisProfile',
      info: 'info',
      personalData: 'personalData',
      brandData: 'brandData'
    }),
    individualData: {
      get () { return this.personalData },
      set(value) { this.storepersonal({ personal: value }); },
    },
    storeBrandData: {
      get () { return this.brandData },
      set(value) { this.updateBrandData({ brand: value }); },
    },
    transform() {
      // watch 無法監聽物件, computed不能修改component的值, 所以顯示會用placeholder
      if (this.channelData.Service === 'LINE') {
        return this.channelData.AuthToken.substr(5,10);
      } else {
        return this.channelData.AuthToken
      }
    },
    token: {
      get () { return this.info.token },
      set(value) { this.updatetoken({ token: value }); },
    },
    phoneNumber: {
      get () { return this.info.phone },
      set(value) { this.updatephone({ phone: value }); },
    },
    storeCountryCode: {
      get () { return this.info.countryCode },
      set(value) { this.updateCountryCode({ code: value }); },
    },
    birth: {
      get () { return this.info.birth },
      set(value) { this.updatebirth({ birth: value }); },
    },
  },
  methods: {
    ...mapMutations({
      updatephone: 'updatephone',
      updatetoken: 'updatetoken',
      updateCountryCode: 'updateCountryCode',
      storepersonal: 'storepersonal',
      updateBrandData: 'updateBrandData'
    }),
    ...mapActions({
      checkAccountGetClientID: 'checkAccountGetClientID',
      checkUserByPhone: 'checkUserByPhone',
      ChTextMsg: 'ChTextMsg',
      checkMember: 'checkMember',
      checkUserByToken: 'checkUserByToken',
      TWtextmsg: 'TWtextmsg',
      getConfig: 'getConfig',
      fastClearance: 'fastClearance',

    }),
    goUrl() {
      var u = navigator.userAgent.toLowerCase(), app = navigator.appVersion;
      if (u.indexOf('android') !== -1) {
        location.href = `sms:1922?body=場所代碼:${this.brandData.shopNo}本簡訊是簡訊實聯制發送，限防疫目的使用`;
      } else {
        location.href = `sms://1922&body=場所代碼:${this.brandData.shopNo}本簡訊是簡訊實聯制發送，限防疫目的使用`;
      }

      // sms://1922&body=場所代碼：${此為特店代碼的變數，由我們系統帶入，是16碼數字}本簡訊是簡訊實聯制發送，限防疫目的使用
      // window.open(`SMSTO:1922:場所代碼：${this.brandData.shopNo}本簡訊是簡訊實聯制發送，限防疫目的使用`)
      // liff.closeWindow()
      // liff.openWindow({
      //   url: `sms:1922?body=場所代碼：${this.brandData.shopNo}本簡訊是簡訊實聯制發送，限防疫目的使用`,
      //   external: true
      // });
    },
    // 解密
    Decrypt(word) {
      // console.log(word);
      var key = "FFzqekWVwgu7Oz28pfyPUlbOk4UusnNc"
      var iv = "2uY28N7v5kVEuFPr"
      const keysStr = CryptoJS.enc.Utf8.parse(key);
      const ivStr = CryptoJS.enc.Utf8.parse(iv);
      let encryptedHexStr = CryptoJS.enc.Base64.parse(word);
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
      let decrypt = CryptoJS.AES.decrypt(srcs, keysStr, {
          iv: ivStr,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      // console.log(decryptedStr);
      return decryptedStr.toString();
    },
    place(val) {
      const word = '範例: ';
      if (val !== '') {
        return word + this.countries.filter(el => el.value === this.countryCode).map(el => el.example)[0]
      } else {
        return word + this.countries.filter(el => el.value === '+886').map(el => el.example)[0]
      }
    },
    a() {
      this.number -= 1;
    },
    b() {
      this.number = 300;
      var si = setInterval(this.a, 1000);
      setTimeout(() => {
        this.number = '';
        // this.phoneVerify = true;
        clearInterval(si);
      }, 300000);
    },
    Alert(val) {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: '格式有誤，請參考範例。',
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
      }).show()
    },
    showAlert(val) {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: val,
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        // onConfirm: (e, promptValue) => {
        //   this.phoneAuth();
        // }
      }).show()
    },
    showAlert2(val) {
      if (val !== 'mobile tag error') {
        this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: val,
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        // icon: 'cubeic-alert'
        }).show()
      } else {
        this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: val + '發生錯誤',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        // icon: 'cubeic-alert'
        }).show()
      }
    },
    checkingPhone() {
      this.$loading.show()
      if (this.phoneNumber.length === 10) {
      // console.log(this.eilisProfile);
      this.checkAccountGetClientID({service: this.$route.params.service, auth: this.eilisProfile.auth})
      .then((res) => {
        // console.log(res);
        if (res.data.result.clientId) {
          this.checkUserByPhone({ phone: this.phoneNumber, clientId: res.data.result.clientId , })
          .then((res)=> {
          // console.log(res);
          // if (this.phoneNumber === '0987747267') {
          //   this.$router.push(`/Register/${this.$route.params.service}?Auth=${this.$route.query.Auth}&Img=${this.channelData.Img}`)
          // }
          if (res.data.result === null ) {
            // this.phoneAuth();
            this.$loading.hide()
            this.phoneAuth();
            // this.$router.push(`/Register/${this.$route.params.service}?Auth=${this.$route.query.Auth}&Img=${this.channelData.Img}`)
          } else if (res.data.point) {
            // this.$router.push(`/initial/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&Img=${this.channelData.Img}&Point=${res.data.point}`)
            this.channelData.Point = res.data.point;
            this.$loading.hide()
            this.phoneAuth();
        }
          else if (res.data.result.services && res.data.result.services[this.$route.params.service] && res.data.result.services[this.$route.params.service][this.eilisProfile.auth]) {
            const content = '此電話已註冊'
            this.$loading.hide()
            this.showAlert(content)
          }
          // 3/17 快速通關
          else {
            this.crossPlatform = true;
            this.userId = res.data.result.userId;
            this.$loading.hide()
            this.phoneAuth();
          }
          })
        }
      })
      } else {
        const content = '格式有誤'
        this.$loading.hide()
        this.showAlert(content)
      }
    },
    phoneAuth() {
      this.$loading.show()
      // console.log(this.equal);
      const sixcodes = `${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}`;
      this.tempCode = sixcodes;
      if (this.crossPlatform === true) {
        this.b();
        this.phoneVerify = true;
        this.$loading.hide()
      }
      // console.log(this.tempCode);
      // service:FB OR LINE ,gate: channel ID or FB ID
      // const word = `成功登錄後，歡迎您升等為${this.eilisProfile.name}的數位會員`
      const words = `你的今日實聯制驗證碼為:`;
      // const words = `使用${this.brand}的驗證碼:`
      // console.log(words);
      // return;
      this.TWtextmsg({ phone: this.phoneNumber, code: words + sixcodes + '(Powered by EILIS )', service: this.$route.params.service, gate: this.eilisProfile.auth,})
      .then((res)=> {
        // console.log(res);
        if (res.data.text !== 'mobile tag error') {
          this.b();
          this.phoneVerify = true;
          this.$loading.hide()
        } else {
          this.showAlert2(res.data.text);
          this.$loading.hide()
          // window.location.reload();
        }
      });
    },
    codeVer() {
      this.$loading.show()
      if (this.verCode === this.tempCode) {
        // const A =  this.getConfig({service: this.$route.params.service, auth: this.eilisProfile.auth,})
        // Promise.all([A]).then(values => {
        //   // console.log(values);
        //   this.storeBrandData = values[0].data.result;
        //   // console.log(this.storeBrandData);
        // })
        this.$loading.hide()
        return this.$router.push(`/Register/${this.$route.params.service}?Auth=${this.$route.query.Auth}&Img=${this.channelData.Img}&`)
      } else {
        let str = '驗證碼錯誤'
        this.showAlert2(str);
        this.$loading.hide()
      }
    },
    change(value, index, text) {
      this.storeCountryCode = value;
    },
    chosen (val) {
      // console.log(val);
      this.value0 = this.options[val][0];
      // console.log(this.value0);
    },
  }
}
</script>

<style lang="scss" scoped>
  .recaptcha-container{
    opacity: 0%;
  }
  .mobile-wrap {
    margin: auto;
    width: 300px;
    height: 750px;
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .mobile-wrap:before {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
    position: absolute;
    // background: rgba(90, 93, 165, .8);
    // background: linear-gradient(to bottom, rgba(90, 93, 165, 1), rgba(0, 0, 0, .7))
  }
  .loadingIcon {
    z-index: 100000;
    display: flex; // 置中
    align-items: center; // 置中
    justify-content: center; // 置中
    margin: 0 auto;
    position: fixed;
    top: 50%;
    left: 0;
    right: 0;
    // margin-top: -270px;
    width: 55px;
    height: 55px;
    color: #ffffff;
    border-radius: 5px;
    background-color: #717171;
    -webkit-text-fill-color: transparent;
  }
  #layer{
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(159, 159, 159, 0.527);
  }
  .menu {
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    max-width: 540px;
    min-width: 300px;
    height: 750px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  .pic {
    position: relative;
    z-index: 1;
    transform: scale(0.2);
    // top: 30px;
    margin:0 auto;
    margin-top: 0px;
    margin-left: -110px;
    height: 210px;
  }
  .title {
    margin-top: 150px;
    font-family:
      'Quicksand',
      'Source Sans Pro',
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      sans-serif;
    display: block;
    font-weight: 500;
    font-size: 35px;
    color: #121313;
    letter-spacing: 1px;
  }
  .item {
    // z-index: 1;
    // border-radius: 10px;
    font-size: 16px;
    width: 80%;
    max-width: 420px;
    min-width: 200px;
    margin: 0 auto 25px ;
  }
  section {
    position: relative;
    background-color: none;
    width: 100%;
    height: 100vh;
  }
  #curve {
    z-index: 1000;
    position: relative;
    transform: scale(4) rotate(6deg);
    bottom: 500px;
    left: 200px;
    width: 100%;
  }
  #curve path {
    fill: rgb(76, 182, 14);
  }
  .bottom {
    right: 0;
    left: 0;
    font-size: 5px;
    position: fixed;
    bottom: 20px;
  }
</style>
